/**
 * Script contents are not HTML-decoded by parsers, so entity-escaped values
 * such as &apos; would reach them literally. Only "<" needs escaping, so that
 * a value cannot close the surrounding script tag.
 */
export const jsonLdScript = data => ({
  type: 'application/ld+json',
  innerHTML: JSON.stringify(data).replace(/</g, '\\u003c')
})

const isEmail = ({ name }) => Boolean(name) && name.toLowerCase() === 'email'

const isPersonalProfile = ({ url }) =>
  Boolean(url) && url.includes('linkedin.com/in/')

const organizationProfiles = (social = []) =>
  social
    .filter(profile => !isEmail(profile) && !isPersonalProfile(profile))
    .map(({ url }) => url)

const personalProfiles = (social = []) =>
  social.filter(isPersonalProfile).map(({ url }) => url)

const withSameAs = (entity, profiles) =>
  profiles.length > 0 ? { ...entity, sameAs: profiles } : entity

export const articleSchema = ({
  title,
  thumbnailUrl,
  datePublishedIso,
  canonicalUrl,
  author,
  site,
  siteUrl
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: title,
  image: thumbnailUrl,
  datePublished: datePublishedIso,
  mainEntityOfPage: canonicalUrl,
  author: withSameAs(
    {
      '@type': 'Person',
      name: author.name,
      jobTitle: author.title,
      url: author.slug && `${siteUrl}${author.slug}`
    },
    personalProfiles(site.social)
  ),
  publisher: {
    '@type': 'Organization',
    name: site.name,
    url: siteUrl
  }
})

export const breadcrumbSchema = ({ category, site, siteUrl }) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: site.name,
      item: siteUrl
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: category.name,
      item: `${siteUrl}${category.slug}`
    }
  ]
})

export const organizationSchema = ({ site, siteUrl }) =>
  withSameAs(
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: site.name,
      url: siteUrl
    },
    organizationProfiles(site.social)
  )

export const webSiteSchema = ({ site, siteUrl }) => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: site.name,
  url: siteUrl,
  inLanguage: 'fr'
})
